module.exports = __webpack_public_path__ + "img/1534075727.a425d992.jpg";